(() => {
  'use strict';
  const root = document.getElementById('rc-city-demo');
  if (!root || root.dataset.initialized) return;
  root.dataset.initialized = 'true';
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const pause = root.querySelector('.rc3-pause');
  const replay = root.querySelector('.rc3-replay');
  const number = root.querySelector('.rc3-phase-num');
  const text = root.querySelector('.rc3-phase-text');
  const phases = [[0, '01', 'A product sparks interest'], [1.5, '02', 'The neighborhood unfolds'], [4.2, '03', 'Local stores take shape'], [6.8, '04', 'An example retailer confirms'], [9.0, '05', 'A nearby next step appears']];
  let frame;
  function update() {
    const clock = root.querySelector('.rc3-progress span').getAnimations()[0];
    const seconds = clock ? (Number(clock.currentTime) % 14000) / 1000 : 11;
    const phase = phases.filter(p => p[0] <= seconds).pop();
    number.textContent = phase[1]; text.textContent = phase[2];
    root.dataset.phase = phase[1];
    if (!reduced.matches) frame = requestAnimationFrame(update);
  }
  function mode() {
    cancelAnimationFrame(frame);
    root.classList.toggle('rc3-running', !reduced.matches);
    root.classList.remove('rc3-paused');
    pause.setAttribute('aria-pressed', 'false');
    pause.disabled = reduced.matches;
    pause.textContent = reduced.matches ? 'Reduced motion · still view' : 'Pause animation Ⅱ';
    replay.textContent = reduced.matches ? 'View the demo ↓' : 'Replay the demo ↻';
    update();
  }
  pause.addEventListener('click', () => {
    if (reduced.matches) return;
    const paused = root.classList.toggle('rc3-paused');
    pause.setAttribute('aria-pressed', String(paused));
    pause.textContent = paused ? 'Resume animation ▶' : 'Pause animation Ⅱ';
  });
  replay.addEventListener('click', () => {
    if (!reduced.matches) {
      root.classList.remove('rc3-paused');
      root.getAnimations({subtree: true}).forEach(animation => { animation.currentTime = 0; });
      pause.setAttribute('aria-pressed', 'false'); pause.textContent = 'Pause animation Ⅱ';
    }
    if (window.innerWidth <= 800) root.querySelector('.rc3-visual').scrollIntoView({behavior: reduced.matches ? 'instant' : 'smooth', block: 'start'});
    updatePhaseOnce();
  });
  function updatePhaseOnce() { number.textContent = reduced.matches ? '05' : '01'; text.textContent = reduced.matches ? 'A nearby next step appears' : 'A product sparks interest'; }
  reduced.addEventListener('change', mode);
  mode();
})();
